import React, { useCallback } from 'react';
import { connectHits } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';
import SearchState from '../../../../../algolia-search/js/components/elements/SearchState';
import SearchResultsForType from '../../../../../algolia-search/js/components/sections/SearchResultsForType';
import useIcscTracking from '@tracking/useIcscTracking';
import { useGetEventName, useHandleLogConversion, useShouldLogConversion } from './hooks';

const SearchResults = ({
    hits,
    cardComponent,
    index,
    listItemComponent,
    parentView, // TODO: Can this be stored in context instead of passed down 2-3 levels?
    query,
    parentSubview,
    transformFunc,
    typePlural,
    resultsPerRow = 3,
    NoResultsText,
}) => {
    const { trackEvent } = useIcscTracking();
    const getEventName = useGetEventName(index, parentView, parentSubview);
    const shouldLogConversion = useShouldLogConversion(index, parentView, parentSubview);
    const handleLogConversion = useHandleLogConversion(shouldLogConversion, trackEvent, index, getEventName);

    const handleGenericClick = useCallback(
        ({ hit }) => {
            trackEvent({
                click: {
                    index: `${process.env.ALGOLIA_ENV_PREFIX}_${index}`,
                    hit,
                    target: `click_search_result_${index}`,
                    value: 'Click Search Result',
                },
            });
            handleLogConversion(hit);
        },
        [handleLogConversion, index, trackEvent],
    );

    const handleAdded = useCallback(
        ({ hit }) => {
            handleLogConversion(hit);
        },
        [handleLogConversion],
    );

    if (hits.length === 0) {
        return <SearchState hitCount={hits.length} NoResultsText={NoResultsText} />;
    }

    return (
        <SearchResultsForType
            CardComponent={cardComponent}
            hits={hits}
            index={index}
            ListItemComponent={listItemComponent}
            isLoggedIn
            onClick={handleGenericClick}
            query={query}
            added={handleAdded}
            typePlural={typePlural}
            transformFunc={transformFunc}
            resultsPerRow={resultsPerRow}
            onMessageSent={({ hit }) => handleLogConversion(hit)}
        />
    );
};

SearchResults.propTypes = {
    cardComponent: PropTypes.any.isRequired,
    hits: PropTypes.any,
    index: PropTypes.string.isRequired,
    listItemComponent: PropTypes.any.isRequired,
    NoResultsText: PropTypes.elementType,
    parentView: PropTypes.string,
    parentSubview: PropTypes.string,
    query: PropTypes.object,
    transformFunc: PropTypes.func,
    typePlural: PropTypes.string,
    resultsPerRow: PropTypes.number,
};

export default connectHits(SearchResults);
